import { apolloClient } from '../vue-apollo';

/**
 * Load app configurations and sync baseCurrencySymbol to localStorage
 * This ensures currency helper has access to the currency symbol immediately
 */
export async function loadAppConfigurations() {
  try {
    const query = require('../settings/api/getAppConfigurations.graphql');
    const { data } = await apolloClient.query({
      query: query,
      fetchPolicy: 'network-only', // Always get fresh config
    });

    if (data && data.getAppConfigurations) {
      const config = data.getAppConfigurations;
      
      // Sync baseCurrencySymbol to localStorage for currency-helper.js
      if (config.baseCurrencySymbol) {
        try {
          localStorage.setItem('BASE_CURRENCY_SYMBOL', config.baseCurrencySymbol);
        } catch (e) {
          console.warn('Failed to save baseCurrencySymbol to localStorage:', e);
        }
      }
      if (config.timeZone) {
        try {
          localStorage.setItem('APP_TIME_ZONE', config.timeZone);
        } catch (e) {
          console.warn('Failed to save timeZone to localStorage:', e);
        }
      }
      if (config.defaultShift) {
        try {
          localStorage.setItem('DEFAULT_SHIFT', config.defaultShift);
        } catch (e) {
          console.warn('Failed to save defaultShift to localStorage:', e);
        }
      }
      if (config.locationConfig) {
        try {
          const locationConfig = { ...config.locationConfig };
          // Geo tenants: label the tiers with the country's own hierarchy names
          // (Governorate/Area/Block in Kuwait, Region/Governorate/District in
          // Saudi, ...) instead of the generic Region/Area/Block defaults.
          if (locationConfig.useGeoLocations === true) {
            try {
              const { data: geo } = await apolloClient.query({
                query: require('../location/api/getLocationCountryInfo.graphql'),
                fetchPolicy: 'cache-first',
              });
              const country = geo && geo.getLocationCountryInfo && geo.getLocationCountryInfo[0];
              if (country && country.hierarchyTemplate && country.hierarchyTemplate.length) {
                locationConfig.geoTierLabels = [...country.hierarchyTemplate]
                  .sort((a, b) => a.level - b.level)
                  .map((t) => t.labelEn || t.entityTypeCode);
              }
            } catch (e) {
              console.debug('Failed to load geo tier labels:', e.message);
            }
          }
          localStorage.setItem('LOCATION_CONFIG', JSON.stringify(locationConfig));
        } catch (e) {
          console.warn('Failed to save locationConfig to localStorage:', e);
        }
      }
      // Phone numbers are stored locally (no country code), so the customer
      // search needs the tenant's code to strip it off a pasted international
      // number. See utils/search-term.js.
      if (config.phoneCode) {
        try {
          localStorage.setItem('APP_PHONE_CODE', String(config.phoneCode));
        } catch (e) {
          console.warn('Failed to save phoneCode to localStorage:', e);
        }
      }

      return config;
    }
  } catch (error) {
    // Silently fail - configurations might not be available yet
    // or user might not be authenticated
    console.debug('Failed to load app configurations:', error.message);
  }
  
  return null;
}
